import script from "./ProfilePictureCached.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfilePictureCached.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__